import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=1397467c"
import script from "./NextSteps.vue?vue&type=script&lang=js"
export * from "./NextSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports